"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Wrench, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroOrleans() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261112" id="hero-orleans" className="relative bg-background text-foreground pt-24 pb-16 md:pt-32 md:pb-24 lg:pt-40 lg:pb-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-lg bg-secondary/20 blur-3xl opacity-30" />
        <div className="absolute bottom-[10%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary/10 blur-3xl opacity-40" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-6 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Badge variant="secondary" className="px-3 py-1 text-sm bg-secondary text-secondary-foreground border-secondary/30 font-default">
              <Wrench className="w-4 h-4 mr-2 text-secondary-foreground" />
              Local Orleans Service
            </Badge>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground leading-tight tracking-tight">
              Junk Removal <span className="text-primary">Orleans</span>
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground max-w-xl leading-relaxed font-default">
              Fast affordable junk removal in Orleans with same day pickups available for furniture, appliances, renovation debris, mattresses, and household junk. We make clearing your space effortless.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto pt-4">
              <Button asChild size="lg" className="w-full sm:w-auto text-base h-12 px-8 bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg shadow-md">
                <Link to="/PricingPage">
                  Get a Free Quote
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-12 px-8 border-primary/20 hover:bg-primary/5 text-primary rounded-lg">
                <Link to="#">
                  Text Us Photos
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-4 pt-6 text-sm text-muted-foreground font-medium">
              <div className="flex items-center gap-1.5">
                <ShieldCheck className="w-5 h-5 text-primary" />
                <span>Fully Insured</span>
              </div>
              <div className="w-1.5 h-1.5 rounded-lg bg-border" />
              <div className="flex items-center gap-1.5">
                <ShieldCheck className="w-5 h-5 text-primary" />
                <span>Eco-Friendly Disposal</span>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative mx-auto w-full max-w-[600px] lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-lg overflow-hidden shadow-2xl border border-border/50 bg-card">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent z-10 mix-blend-overlay" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/orleans_junk_removal_truck_team.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/orleans_junk_removal_truck_team.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/orleans_junk_removal_truck_team.png-wvc-sizes" alt="Two workers in black polos carrying furniture near a branded junk removal truck in an Orleans suburb" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-[1/1]" loading="eager" />
              
              {}
              <div className="absolute bottom-6 left-6 right-6 md:right-auto md:w-72 bg-background/95 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-border z-20">
                <div className="flex items-start gap-4">
                  <div className="bg-secondary/20 p-2.5 rounded-lg shrink-0">
                    <Wrench className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <p className="text-sm font-bold font-default text-foreground">Same Day Service</p>
                    <p className="text-xs text-muted-foreground mt-1">Available for most residential and commercial pickups in Orleans.</p>
                  </div>
                </div>
              </div>
            </div>
            
            {}
            <div className="absolute -inset-4 bg-secondary/10 rounded-lg -z-10 transform rotate-2 scale-105 transition-transform duration-700 hover:rotate-1" />
          </div>

        </div>
      </div>
    </section>;
}